<div class="modal-header w-100 mb-3">
  <div class="modal-title">
    <h1 class="title-lg">Continue Shopping as...</h1>
    <h6 class="title-desc text-start">
      Please select how would you like to continue shopping as
    </h6>
  </div>
  <i class="close btn-close" (click)="onNoClick()"></i>
</div>

<div mat-dialog-content>
  <form (submit)="onSubmit()">
    <div class="container">
      <div class="row">
        <div class="col-md-6 text-center">
          <label>
            <input
              type="radio"
              [(ngModel)]="data.userType"
              name="test"
              value="marihub"
            />
            <img src="assets/Images/MariHubLogo.png" class="w-50" />
            <p class="mt-2">Continue As MariHub</p>
          </label>
        </div>
        <div class="col-md-6 text-center">
          <label>
            <input
              type="radio"
              [(ngModel)]="data.userType"
              name="test"
              value="client"
            />
            <img src="assets/Images/ClientLogo.png" class="w-50" />
            <p class="mt-2">Continue As Client</p>
          </label>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="float-end modal-footer w-100">
      <button class="btn btn-secondary m-2" (click)="onNoClick()" type="button">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary float-end m-2">
        Continue
      </button>
    </div>
  </form>
</div>
